import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Timeline } from 'primeng/timeline';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-ticket-timeline',
  imports: [Timeline, SharedModule],
  templateUrl: './ticket-timeline.component.html',
  styleUrl: './ticket-timeline.component.scss'
})
export class TicketTimelineComponent {
  events: any[] = [];
  @Input() timelineData: any[] = [];
  @Output() editEvent = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['timelineData'] && changes['timelineData'].currentValue != changes['timelineData'].previousValue) {
      console.log("timelineData", this.timelineData);
      if (this.timelineData?.length > 0) {
        this.events = this.timelineData;
        console.log("events", this.events);
      } else {
        // Default timeline data for demonstration
        this.events = [
        ];
      }
    }
  }

  getInitials(name: string) {
    if (!name) {
      return "UN"
    }
    const initialName = name.split(' ').map(n => n[0]).join('');
    // return length 2 initials
    return initialName.length > 2 ? initialName.slice(0, 2) : initialName;
  }

  getMarkerClass(type: string): string {
    switch (type) {
      case 'creation':
        return 'marker-creation';
      case 'assignment':
        return 'marker-assignment';
      case 'update':
        return 'marker-update';
      case 'comment':
        return 'marker-comment';
      case 'attachment':
        return 'marker-attachment';
      default:
        return 'marker-default';
    }
  }

  getTypeBadgeClass(type: string): string {
    switch (type) {
      case 'creation':
        return 'badge-creation';
      case 'assignment':
        return 'badge-assignment';
      case 'update':
        return 'badge-update';
      case 'comment':
        return 'badge-comment';
      case 'attachment':
        return 'badge-attachment';
      default:
        return 'badge-default';
    }
  }

  getTypeLabel(type: string): string {
    switch (type) {
      case 'creation':
        return 'Created';
      case 'assignment':
        return 'Assigned';
      case 'update':
        return 'Updated';
      case 'comment':
        return 'Comment';
      case 'attachment':
        return 'Attachment';
      default:
        return 'Activity';
    }
  }

  onEditEvent(event: any) {
    console.log('Edit event:', event);
    this.editEvent.emit(event);
  }

  onDeleteEvent(event: any) {
    console.log('Delete event:', event);
    this.deleteEvent.emit(event);
  }
}
